import React from 'react';
import { initializePendo } from './helper';

export const useInitializePendo = (candidate, jobChatId) => {
	React.useEffect(
		() => {
			initializePendo(candidate, jobChatId);
		},
		[candidate]
	);
};
